<template>
  <div>
    <input type="checkbox" id="check" checked="true" />
    <Sidebar></Sidebar>
    <router-view />
  </div>
</template>

<script>
import Sidebar from '@/components/back/SiderBar';
import loginCheckRequest from '@/assets/js/api/back/apiCheckLogin';
import { mapState, mapMutations } from 'vuex';
export default {
  components: { Sidebar },
  created() {
    let token = document.cookie.replace(
      /(?:(?:^|.*;\s*)token\s*=\s*([^;]*).*$)|^.*$/,
      '$1',
    );
    this.SET_USER({ token });
    this.tokenCheck();
  },
  methods: {
    ...mapMutations(['SET_USER']),
    tokenCheck() {
      loginCheckRequest
        .post('', {
          api_token: this.user.token,
        })
        .then(response => {
          response.data.success
            ? () => {
                return;
              }
            : this.$router.push({ name: 'login' });
        })
        .catch(() => {
          this.$router.push({ name: 'login' });
        });
    },
  },
  computed: {
    ...mapState({
      user: 'user',
    }),
  },
};
</script>

<style lang="scss" scoped></style>
